import Vuex from 'vuex';
import { createStore } from 'vuex'
import { apiV1 } from '@/providers'
import customers from './modules/customers'

Vuex.Store.prototype.$apiV1 = apiV1

export default createStore({
  modules: {
    customers
  },
  state: {
    user: JSON.parse(localStorage.getItem('user')),
    companyLogo: localStorage.getItem('companyLogo')
  },
  mutations: {
    setUser (state, n) {
      state.user = n
    },
    setCompanyLogo (state, n) {
      state.companyLogo = n
    }
  },
  actions: {
  },
  getters: {
    getUser (state) {
      return state.user
    },
    getCompanyLogo (state) {
      return state.companyLogo
    }
  }
})